export default __webpack_public_path__ + "static/media/sideLogo.37f92ff9.png";